<template>
	<div class="widget-guide-frame">
		<i class="coachmark demo-icon icon-sf-close" @click="clearDisplayCoachMarkFlag_" />
		<div v-if="widgetSideBar" class="icon-container" :style="dragStyle">
			<el-tooltip :manual="true" :value="true" popper-class="coachmark" effect="light" :content="sidebarTooltipMessage" placement="left">
				<icon-drag />
			</el-tooltip>
		</div>
		<el-tooltip
			v-else
			:value="showCoachMark_ && readyMessage"
			popper-class="coachmark"
			effect="light"
			:content="buttonTooltipMessage"
			placement="left-start"
		>
			<div class="widget add-widget-button coachmark focusing" @click="toggleWidgetSide">
				<span class="sf-icon icon-sf-plus"></span>
			</div>
		</el-tooltip>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/Widget/store/helpers';

import IconDrag from './IconDrag.vue';
export default {
	components: {
		IconDrag
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		toggleWidgetSide() {
			this.$store.commit('widgetStore/toggleWidgetSideBar', true);
		},
		displayCoachMark() {
			const elem = document.getElementById('sidebarComponent0');
			const pos = this.widgetSideBar && elem && elem.getBoundingClientRect();
			this.pos = pos;
			// console.log('position', pos);

			elem.classList.add('first-item');
			elem.draggable = true;

			return pos;
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		dragStyle() {
			const { top, right, width, height } = this.pos;
			return {
				top: `${top}px`,
				right: `${width}px`,
				width: `${width}px`,
				height: `${height}px`
			};
		},
		buttonTooltipMessage() {
			const msg = this.showCoachMark_ && this.getMessage_('SWCC000763');
			return msg;
		},
		sidebarTooltipMessage() {
			const msg = this.getMessage_('SWCC000835');
			return msg;
		},
		readyMessage() {
			return !_.isEmpty(this.getMessage_('SWCC000763'));
		}
	},
	watch: {
		widgetSideBar(v) {
			if (v) {
				this.displayCoachMark();
			}
		}
	},
	data() {
		return {
			pos: {
				left: 0,
				top: 0
			}
		};
	}
};
</script>

<style></style>
